import { Flex, Avatar, Text, Center, Button } from '@chakra-ui/react';
import { NotificationCard } from '../components/Card';
import { NotificationTime } from '../components/Time';
import { decode } from 'js-base64';
import { NotificationLink } from '../components/NotificationLink';
import { useMarkAsReadMutation } from '@/store/query/notification';
import { LayersThree02 } from '@kula-ai/icons-core';
import { KText } from '@/ui-library/components';

export const AddedToJobHiringTeam = ({ notification, onClose }) => {
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));
  const [markAsRead] = useMarkAsReadMutation();
  const { job_name, job_url, user, performed_by } = data;
  const jobId = job_url.split('/').pop();
  const { roles } = user;
  const { name: performedByName, avatar_url: performedByAvatar } = performed_by;

  return (
    <NotificationCard notification={notification}>
      <Flex alignItems="baseline" gap="6px">
        <Center minW="46px" h="46px" borderRadius="full" bg="ats-tertiary">
          <LayersThree02
            size="1em"
            color="var(--kula-colors-primary-500)"
            className="kula-icon"
          />
        </Center>
        <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start">
          <Text>
            <Text as="span" size="sm">
              You’ve been added to the hiring team for
            </Text>
            <KText color="primary-600" as="span" size="sm-bold">
              <NotificationLink
                to={`/jobs/${jobId}`}
                label={job_name}
                onClose={onClose}
                notification={notification}
                data-test-id="job-link"
              />
            </KText>
          </Text>

          <Text size="sm-bold">Details</Text>
          <Flex
            border="1px solid"
            borderColor="border-color"
            borderRadius="sm"
            p="14px"
            flexDir="column"
            gap="6px"
            mt="-6px"
          >
            <Text size="sm-bold">Role</Text>
            <Text size="sm" mb="6px">
              {roles?.join(', ')}
            </Text>
            <Text size="sm-bold">Added by</Text>
            <Flex mb="6px" gap="6px" alignItems="center">
              <Avatar
                size="2xs"
                borderRadius="4px"
                className="avatar-xs"
                name={performedByName}
                src={performedByAvatar}
              />
              <Text size="sm">{performedByName}</Text>
            </Flex>
          </Flex>
          <NotificationTime notification={notification} />
          <Button
            w="fit-content"
            variant="primary"
            borderRadius="8px"
            onClick={() => {
              markAsRead();
              window.open(job_url, '_self');
              onClose();
            }}
            maxH="34px"
            data-test-id="go-to-job-button"
          >
            Go to Job
          </Button>
        </Flex>
      </Flex>
    </NotificationCard>
  );
};
